import { render } from "./Abonnementen.vue?vue&type=template&id=4c2a3dd2"
import script from "./Abonnementen.vue?vue&type=script&lang=js"
export * from "./Abonnementen.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__